import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../auth";

export const settingsMainGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.connectedUserCanManageSettings() || router.createUrlTree(["/unauthorizedroute"]);
};
